import { isNil } from 'lodash'

// PDF export goes through the browser's native print dialog rather than a
// rendering dependency (html2canvas/jsPDF): the user keeps control of paper
// size and orientation, and there is no extra bundle weight. The trade-off is
// that charts export as a static snapshot with no hover/interactivity.

const SNAPSHOT_CLASS = 'print-chart-snapshot'
const ECHART_SELECTOR = 'div[_echarts_instance_]'

export const removePrintChartSnapshots = () => {
  document.querySelectorAll(`.${SNAPSHOT_CLASS}`).forEach((node) => node.remove())
}

// ECharts paints to <canvas>, which does NOT reflow when the print stylesheet
// re-lays-out the page — charts come out clipped or stretched. Each live chart
// gets a print-only <img> sibling instead (images scale cleanly); the print
// stylesheet hides the canvas whenever its snapshot exists.
export const addPrintChartSnapshots = (selector = ECHART_SELECTOR) => {
  removePrintChartSnapshots()
  const images = []
  document.querySelectorAll(selector).forEach((root) => {
    const canvas = root.querySelector('canvas')
    if (isNil(canvas) || !canvas.width) {
      return
    }
    try {
      const image = document.createElement('img')
      image.src = canvas.toDataURL('image/png')
      image.className = SNAPSHOT_CLASS
      root.insertAdjacentElement('afterend', image)
      images.push(image)
    } catch {
      // Tainted or zero-size canvas — printing that chart live beats a blank card.
    }
  })
  return images
}

export const hasPrintChartSnapshots = () => !isNil(document.querySelector(`.${SNAPSHOT_CLASS}`))

// Data-URL <img>s decode asynchronously and printing immediately can capture
// them blank, so every decode is awaited before the dialog opens.
export const printToPdf = async (selector) => {
  const images = addPrintChartSnapshots(selector)
  const decoded = await Promise.allSettled(images.map((image) => image.decode()))
  // A snapshot that never decoded prints as a blank box AND suppresses the live
  // chart, since the print rule hides a canvas whenever a snapshot sits next to
  // it. Drop it so the real chart prints instead.
  decoded.forEach((result, index) => {
    if (result.status === 'rejected') {
      images[index].remove()
    }
  })
  window.print()
}
